import { Routes } from '@angular/router';
import { SyllabicKeyboardPlusApplyRulePage } from './syllabic-keyboard-plus-apply-rule-page/syllabic-keyboard-plus-apply-rule-page';
import { SyllabicKeyboardPlusChooseRulePage } from './syllabic-keyboard-plus-choose-rule-page/syllabic-keyboard-plus-choose-rule-page';
import { SyllabicKeyboardPlusDirectRuleApplicationPage } from './syllabic-keyboard-plus-direct-rule-application-page/syllabic-keyboard-plus-direct-rule-application-page';
import { SyllabicKeyboardPlusFreeformPage } from './syllabic-keyboard-plus-freeform-page/syllabic-keyboard-plus-freeform-page';
import { SyllabicKeyboardPlusKlankvoetenPage } from './syllabic-keyboard-plus-klankvoeten-page/syllabic-keyboard-plus-klankvoeten-page';
import { SyllabicKeyboardPlusPage } from './syllabic-keyboard-plus-page';

export const mechanicSyllabicKeyboardPlusRoutes: Routes = [
  {
    path: '',
    component: SyllabicKeyboardPlusPage,
  },
  {
    path: 'klankvoeten',
    component: SyllabicKeyboardPlusKlankvoetenPage,
  },
  {
    path: 'apply-rule',
    component: SyllabicKeyboardPlusApplyRulePage,
  },
  {
    path: 'freeform',
    component: SyllabicKeyboardPlusFreeformPage,
  },
  {
    path: 'choose-rule',
    component: SyllabicKeyboardPlusChooseRulePage,
  },
  {
    path: 'direct-rule-application',
    component: SyllabicKeyboardPlusDirectRuleApplicationPage,
  },
];
